export const analysisSettingsConfig = {
    modalTitle: {
        lineAnalysis: "Line Analysis Settings",
        tableAnalysis: "Table Analysis Settings"
    },
    modalSubTitle: {
        documents: "Select Documents (Optional)"
    },
    lblAnalysis: "Choose Analysis Flow",
    lblOptionNotes: "Notes",
    lblOptionCustom: "Custom",
    msgTooltipOptionCustom: "Selecting this option allows generating line analysis without Q&A",
    lblOptionQA: "Q&A",
    lblOptionUseQA: "Use Q&A",
    lblOptionGenNewQA: "Generate new",
    msgTooltipOptionGenNewQA: "Selecting this option enables Q&A when generating Line Analysis. Where Q&A has previously been generated, the output will be replaced.",
    lblOptionUseExisting: "Use existing",
    msgTooltipOptionUseExisting: "Selecting this option applies the existing Q&A when generating Line Analysis",
    lblPromptLibrary: "Choose Prompt Library",
    msgNoPersonalPrompts: "No personal prompts available",
    lblPromptName: "Prompt Name",
    lblSelectAll: "Select All",
    msgNoDocs: "No documents available",
    msgNoDocsInfo: "Access the Document Library to check the status of project documents",
    msgNoSearchDocs: "No documents found",
    msgDeletedDocs: "The documents above were previously selected for Line Analysis, but have since been deleted and therefore will nonlonger be considered in generating Line Analysis.",
    lblLineItems: "Choose Line Items",
    msgToastSelectedAllDocs: "This selection may result in the Line Analysis taking longer to complete.",
    msgToastLAInProgress: "Line Analysis on this table is currently in progress. Document selection cannot be changed until this process in complete.",
    btnLabelClose: "Close",
    btnLabelNext: "Next",
    msgTooltipSelectPrompt: "Select a prompt to continue",
    btnLabelConfirm: "Confirm",
    btnLabelCancel: "Cancel",
    btnLabelBack: "Back",
    msgTooltipConfirm: "Click to initiate Line Analysis"
};